import { ReceiveCouponStore } from "./ReceiveCoupon";

export default {
	receiveCoupon: ReceiveCouponStore,
};